import React, {useEffect, useState} from 'react';
import * as AC from '../../actions/actionTypes';
import {useDispatch, useSelector} from 'react-redux';
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Button,
} from '@mui/material';
import {
  addCard,
  editCard,
  getCardDetails,
  getElevatorsByEntrance,
} from '../../actions';
import Select from '../Select';
import {useFormInput} from '../../utils/utilities';
import CustomButton from '../CustomButton';
import {useParams, useNavigate} from 'react-router-dom';
import {fieldError, isFieldIvalid} from '../../utils/errorHandler';
import { getCustomersByCode, getCustomersBySite } from '../../actions/customersActions';

const CardModal = ({customer, edit}) => {
  const dispatch = useDispatch();
  const {id} = useParams();
  const navigate = useNavigate();
  const {entranceElevators, elevatorsLoading} = useSelector(s => s.elevators);
  const {cardById, cardsLoading, cardsError} = useSelector(s => s.cards);
  const { customerByCard } = useSelector(s => s.customers);

  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [elevator, setElevator] = useState('');
  const [codeType, setCodeType] = useState('seperated');
  const [access, setAccess] = useState(Array(16).fill(0));
  const cardId = id;
  

  const code = useFormInput('');
  const siteCode = useFormInput('');
  const siteNo = useFormInput('');
  const allChecked = () => {
    if (access.some(i => +i === 0)) {
      return false;
    }
    return true;
  };

  const onChangeElevator = value => {
    setElevator(value);
  };


  console.log("Chek here: ", customerByCard)

  const onSubmit = e => {
    e.preventDefault();
    const accessClone = [...access];
    const accessString = accessClone.reverse().join('');
    const siteCodeValue = codeType === 'seperated' ? +siteCode.value : null;
    const siteNoValue = codeType === 'seperated' ? +siteNo.value : null;
    const codeValue = codeType !== 'seperated' ? +code.value : null;
    if (siteCodeValue && siteNoValue) {
      dispatch(getCustomersBySite( siteCodeValue, siteNoValue, {} ));
    }
    if(codeValue){
      dispatch(getCustomersByCode( codeValue, {}, ));
    }
    const values = [
      customer.id,
      elevator,
      siteCodeValue,
      siteNoValue,
      codeValue,
      accessString,
    ];
      if (edit) {
        dispatch(editCard(...values, cardId));
      } else {
        dispatch(addCard(...values));
      }
  };

  useEffect(() => {
    
  }, [siteCode.value, siteNo.value, dispatch]);

  useEffect(() => {
    if (cardsError && cardsError !== '') {
      if(edit) {
        if(cardsError.code === "Card with that code exists!"){
          setErrorMessage(`Card already exits and it is allocated to customer : ${customerByCard?.firstName} ${customerByCard?.lastName}`);
          setOpenErrorDialog(true);
        }
        else{
          setErrorMessage(`Internal Server Error`);
          setOpenErrorDialog(true);
        }
      }
      else{
        setErrorMessage(`Card already exits and it is allocated to customer : ${customerByCard?.firstName} ${customerByCard?.lastName}`);
        setOpenErrorDialog(true);
      }
    }
  }, [cardsError, customerByCard]);

  const handleRadioChange = e => {
    e.preventDefault();
    setCodeType(e.target.value);
  };
  const handleCheckAll = e => {
    const updatedAccess = [...access];
    for (let i in updatedAccess) {
      if (e.target.checked) {
        updatedAccess[i] = 1;
      } else {
        updatedAccess[i] = 0;
      }
    }
    setAccess([...updatedAccess]);
  };
  const handleAccessChange = e => {
    const updatedAccess = [...access];
    const value = e.target.checked ? 1 : 0;
    updatedAccess[+e.target.dataset.index] = value;
    setAccess([...updatedAccess]);
  };

  useEffect(() => {
    if (edit && cardById) {
      if (entranceElevators) {
        setElevator(cardById.elevatorId);
      }
      siteNo.manuallyChange(cardById.siteNo);
      siteCode.manuallyChange(cardById.siteCode);
      code.manuallyChange(cardById.code);
      const cardAccess = cardById.access.split('').reverse();
      setAccess([...cardAccess]);
    }
  }, [entranceElevators, cardById]);

  const handleDialogClose = () => {
    setOpenErrorDialog(false);
    dispatch({ type: AC.ADD_CARD_FAILED , payload: '' });
  };

  useEffect(() => {
    dispatch(getElevatorsByEntrance(customer.entranceId));
    if (edit) {
      dispatch(getCardDetails(cardId));
    }
  }, []);

  const handleCustomerRedirect = () => {
    if (customerByCard?.id) {
      navigate(`/customers/${customerByCard?.id}`); 
    }
  };

  return (
    <>
      <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
        {edit ? 'Edit card' : 'Add new card'}
      </Typography>
      <form onSubmit={onSubmit}>
        <Box display="flex" m="1rem" gap="3rem" position="relative">
          <Box
            display="flex"
            flexDirection="column"
            mt="2rem"
            gap="1rem"
            flex={2}>
            <Select
              items={entranceElevators}
              value={elevator}
              onChangeValue={onChangeElevator}
              label="Elevator"
              disabled={elevatorsLoading}
              required
              error={isFieldIvalid(cardsError, 'elevatorId')}
              helperText={fieldError(cardsError, 'elevatorId')}
            />
            <RadioGroup value={codeType} onChange={handleRadioChange}>
              <FormControlLabel
                value="seperated"
                control={<Radio />}
                label="Enter code seperated"
              />
              <FormControlLabel
                value="entire"
                control={<Radio />}
                label="Enter entire code"
              />
            </RadioGroup>
            {codeType === 'seperated' ? (
              <>
                <TextField
                  {...siteCode}
                  required
                  type="number"
                  inputProps={{min: 0, max: 255}}
                  label="Site code"
                  fullWidth
                  error={isFieldIvalid(cardsError, 'siteCode')}
                  helperText={fieldError(cardsError, 'siteCode')}
                />
                <TextField
                  {...siteNo}
                  required
                  type="number"
                  inputProps={{min: 0, max: 65535}}
                  label="Site No"
                  fullWidth
                  error={isFieldIvalid(cardsError, 'siteNumber')}
                  helperText={fieldError(cardsError, 'siteNumber')}
                />
              </>
            ) : (
              <TextField
                {...code}
                required
                type="number"
                label="Code"
                fullWidth
                error={isFieldIvalid(cardsError, 'code')}
                helperText={fieldError(cardsError, 'code')}
              />
            )}
            <CustomButton loading={cardsLoading} type="submit">
              Submit
            </CustomButton>
          </Box>
          <Box flex={1} display="flex" flexDirection="column">
            <Typography variant="h6" mb="1rem">
              Access:
            </Typography>
            <FormControlLabel
              checked={allChecked()}
              onChange={handleCheckAll}
              label="Check All"
              control={<Checkbox />}
            />
            {access.map((item, index) => (
              <FormControlLabel
                checked={+item === 1}
                onChange={handleAccessChange}
                label={`Floor ${index}`}
                control={<Checkbox inputProps={{'data-index': index}} />}
              />
            ))}
          </Box>
        </Box>
      </form>

      {/* Error Dialog */}
      <Dialog open={openErrorDialog} onClose={handleDialogClose}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography sx={{
            fontSize: '18px', 
            fontWeight: 'semi-bold', 
           
          }}>{errorMessage}</Typography>
          <Button onClick={handleCustomerRedirect} color="primary"
          sx={{
            backgroundColor: '#1976d2', // Blue background color
            color: '#fff', 
            '&:hover': {
              backgroundColor: '#1565c0', 
            },
            marginLeft: '-2px',
            marginTop: '10px',
            padding: '8px 12px',
            borderRadius: '4px', 
            fontSize: '14px', 
            fontWeight: 'bold', 
           
          }}
          >
            Go to Customer
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CardModal;
